import { render, staticRenderFns } from "./drawLots.vue?vue&type=template&id=6d6ab006&scoped=true&"
import script from "./drawLots.vue?vue&type=script&lang=js&"
export * from "./drawLots.vue?vue&type=script&lang=js&"
import style0 from "./drawLots.vue?vue&type=style&index=0&id=6d6ab006&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d6ab006",
  null
  
)

export default component.exports